import { render, staticRenderFns } from "./broadcast-template.vue?vue&type=template&id=469d8db3&"
import script from "./broadcast-template.vue?vue&type=script&lang=js&"
export * from "./broadcast-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports